// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules_dev/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p.faq-answer{margin:15px 0}p.faq-answer a{color:#000;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
